var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"erji"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"menu-wp fl visible-lg-block"},[_c('hmenu',{attrs:{"curID":this.curID,"menuID":this.menuID}})],1),_c('div',{staticClass:"erji-content-wp"},[_c('router-view')],1),_c('div',{staticClass:"clear"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }